import { useSelector } from 'react-redux';
import selectors from '../../../../selectors/selectors.js';
import React from 'react';
import { putContact } from '../../../../redux/actions/leadsActions.js';
import setQuery from '../../../../lib/setQuery.js';
import ContactCardDetails from 'screens/leadModal/leadData/leadDataContactsPane/ContactCardDetails.js';
import SVG from 'images/svg/SVG.js';
import copy from 'copy-to-clipboard';
import { ModifyContextState } from 'context/toastContext.js';

const updatePrimaryContact = (data, serviceProviderId, primaryState) => {
  putContact(
    {
      lead_id: data.lead_id,
      contact_id: data.id,
    },
    {
      service_provider_id: serviceProviderId,
      primary: primaryState,
    }
  );
};

const ContactCard = ({ contact = {} }) => {
  const serviceProviderId = useSelector(selectors.serviceProviderId);
  const primaryContactId = (useSelector(selectors.activeLead) || {}).primary_contact_id;

  const handlePrimaryClick = () => {
    if (primaryContactId !== contact.id) {
      updatePrimaryContact(contact, serviceProviderId, primaryContactId === contact.id ? '0' : '1');
    }
  };

  const handleCopyClick = (n) => {
    copy(n, { format: 'text/plain' });
    ModifyContextState.setToastMessage('Copied!');
  };

  return (
    <div className={`lead-data-card contact-card ${primaryContactId === contact.id ? 'primary-contact' : ''}`}>
      <div className={'contact-card-header'}>
        <div className={'left'}>
          <span className="icon appointment">
            <SVG icon={'Person'} />
          </span>
          <div className="header">
            <div className={'contact-name'} data-title="Copy" onClick={() => handleCopyClick(`${contact.first_name} ${contact.last_name}`)}>{`${contact.first_name} ${contact.last_name}`}</div>
            {contact.title && <div className={'contact-description'}>{contact.title}</div>}
          </div>
        </div>
        <div className={'card-controls'}>
          <div className={'card-control'} onClick={() => setQuery({ contact: contact.id, tab: 'contacts' })} data-title={'Edit'}>
            <SVG icon={'Notes'} />
          </div>
          <div className={`card-control is-primary`} onClick={handlePrimaryClick} data-title={primaryContactId === contact.id ? 'Primary' : 'Make Primary'}>
            <SVG icon={'BasicStar'} />
          </div>
        </div>
      </div>
      <ContactCardDetails contact={contact} />
    </div>
  );
};

export default ContactCard;
